import { devDockerLoopbackApiOrigin } from './devDockerLoopback';

/** REST API origin. Development rewrites api.localhost → localhost:4002 (session cookies). */
export function getApiOrigin(): string {
  return devDockerLoopbackApiOrigin(process.env.REACT_APP_API);
}
